import { h, Component, Host, State, Element, Prop, Watch, Method } from "@stencil/core";
import { ColorableComponent, applySchemeDelegate, setCssVariablesDelegate } from "../../common/colorable-component";
import { DividerOrientation, DividerSchemeDefinition, DividerSchemeName } from "./constants/divider-types";
import { DIVIDER_SCHEME_CONFIG, DIVIDER_SCHEME_MAP } from "./constants/divider-constants";
import { DividerSchemeConfiguration } from "../../constants/colors";
import pfx from "../../utils/style-class-prefix-helper";
import { BackgroundColor } from "../background/constants/background-types";
import { StyledComponent } from "../../decorators/styled-component";
// import { InitLogging } from "../../decorators/init-logging";

@Component({
  tag: "eon-ui-divider",
  styleUrl: "divider.scss",
  shadow: true
})
export class Divider implements ColorableComponent<DividerSchemeConfiguration<DividerSchemeDefinition>> {
  // @InitLogging() sentryTransaction;
  schemeConfig: DividerSchemeConfiguration<DividerSchemeDefinition> = DIVIDER_SCHEME_CONFIG;
  schemeMap = DIVIDER_SCHEME_MAP;

  /**
   * The components active scheme. If {@link scheme} is set, it will be set to the corresponding scheme.
   * If not set, the component will try to calculate it based on the nearest enclosing background information given by inner-background attribute or eon-ui-background component.
   */
  @State() activeScheme: DividerSchemeDefinition;

  @StyledComponent() component: any;
  @Element() hostElement: HTMLEonUiDividerElement;

  /**
   * The name of the color scheme of the component.
   * If not set, the component will try to calculate it based on the nearest enclosing background information given by inner-background attribute or eon-ui-background component.
   */
  @Prop({ reflect: true }) scheme: DividerSchemeName;

  /**
   * Orientation of the divider. Either 'vertical' or 'horizontal'. Default is horizontal.
   */
  @Prop() orientation: DividerOrientation = "horizontal";

  /**
   * This method can be called to re-trigger the automatic background color detection
   */
  @Method()
  async updateScheme(backgroundColor?: BackgroundColor) {
    applySchemeDelegate(this, backgroundColor);
  }

  componentWillLoad() {
    this.applyScheme();
  }

  componentDidLoad() {
    this.setCssVariables();
  }

  @Watch("scheme")
  applyScheme() {
    applySchemeDelegate(this);
  }

  @Watch("activeScheme")
  setCssVariables(): void {
    setCssVariablesDelegate(this);
  }

  render() {
    return (
      <Host>
        <div class={pfx({ "divider-wrapper": true, [this.orientation]: true })}>
          <hr></hr>
        </div>
      </Host>
    );
  }
}
